export default __webpack_public_path__ + "static/media/withdrawals-chart.9060cc1a.svg";